export default __webpack_public_path__ + "static/media/audio-icon.7f34892a.svg";